/**
 * Unified filter bar height (search + dropdowns + clear).
 * Default SearchInput uses py-2 and ends up taller than Button md (~35px).
 */
export const FILTER_BAR_HEIGHT_CLASS = '!h-10 min-h-[40px]';

/** SearchInput wrapper: fixes input height and vertically centers absolutely positioned icons. */
export const FILTER_BAR_SEARCH_INPUT_CLASSNAME = [
  '[&_input]:!h-10 [&_input]:!min-h-[40px] [&_input]:!py-0 [&_input]:!leading-none [&_input]:text-sm',
  '[&>span:first-child]:left-3 [&>span:first-child]:top-1/2 [&>span:first-child]:-translate-y-1/2',
  '[&>button]:right-2 [&>button]:top-1/2 [&>button]:-translate-y-1/2',
].join(' ');

/** Chevron-style icons on filter triggers (Lucide svg inside the button). */
export const FILTER_BAR_BUTTON_ICON_CLASSNAME = '[&_svg]:!h-[20px] [&_svg]:!w-[20px]';

/** Extra class for filter Buttons (dropdowns and clear). Typography stays in DashboardButton. */
export const FILTER_BAR_BUTTON_CLASSNAME = `${FILTER_BAR_HEIGHT_CLASS} leading-none ${FILTER_BAR_BUTTON_ICON_CLASSNAME}`;
